import { useState, useEffect } from 'react'


let loadedScripts = {}

export const clearLoadedScripts = () => loadedScripts = {}

const loadScript = (src, async = true) => {
  if (loadedScripts[src] === true) {
    return Promise.resolve()
  }

  if (loadedScripts[src]) {
    return loadedScripts[src]
  }

  loadedScripts[src] = new Promise((resolve, reject) => {
    const script = document.createElement('script')

    script.async = async
    script.type = 'text/javascript'
    script.src = src

    script.onerror = (err) => {
      console.error(`Script "${src}" load error: ${err}`)

      if (script.parentNode) {
        script.parentNode.removeChild(script)
      }

      reject(err)
    }

    script.onload = () => {
      console.info(`Script "${src}" loaded`)
      resolve()

      loadedScripts[src] = true
    }

    document.head.appendChild(script)
  })

  return loadedScripts[src]
}

const loadScriptsSerially = async (srcs, async) => {
  for (let i = 0; i < srcs.length; i++) {
    await loadScript(srcs[i], async)
  }
}


const useScriptsLoader = (srcs, opts) => {
  const { async, serial, skip } = opts || {}

  const isLoaded = srcs.every((src) => (
    loadedScripts[src] === true
  ))

  const [ state, setState ] = useState({
    isLoading: !isLoaded,
    error: null,
  })

  const { isLoading, error } = state

  useEffect(() => {
    if (isLoaded || skip) {
      return
    }

    let isMounted = true
    let promise

    if (serial) {
      promise = loadScriptsSerially(srcs, async)
    }
    else {
      promise = Promise.all(srcs.map((src) => loadScript(src, async)))
    }

    promise
      .then(() => {
        if (isMounted) {
          setState({ isLoading: false, error: null })
        }
      })
      .catch((err) => {
        if (isMounted) {
          setState({ isLoading: false, error: err })
        }
      })

    return () => {
      isMounted = false
    }
  }, [])

  return {
    isScriptLoading: isLoading,
    scriptLoadingError: error,
    isScriptLoaded: !isLoading && !error,
  }
}


export default useScriptsLoader